import React from "react";
import PortfolioGallery from "./PortfolioGallery";

function Portfolio() {
  return (
    <div >
      <p className="bg-gray-100 p-16 text-xl md:text-4xl border-t-2">Portfolio</p>
      <div className="flex flex-wrap justify-center mb-20">
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/158028/bellingrath-gardens-alabama-landscape-scenic-158028.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/126271/pexels-photo-126271.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/698675/pexels-photo-698675.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/255441/pexels-photo-255441.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/1279330/pexels-photo-1279330.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/3756523/pexels-photo-3756523.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/1092730/pexels-photo-1092730.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/2983101/pexels-photo-2983101.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/247204/pexels-photo-247204.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/1162983/pexels-photo-1162983.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/458766/pexels-photo-458766.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/1251007/pexels-photo-1251007.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/15286/pexels-photo.jpg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/4755029/pexels-photo-4755029.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/2258536/pexels-photo-2258536.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/3244513/pexels-photo-3244513.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/567540/pexels-photo-567540.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/689784/pexels-photo-689784.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/535431/pexels-photo-535431.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/535431/pexels-photo-535431.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/4842496/pexels-photo-4842496.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/1779487/pexels-photo-1779487.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/4472968/pexels-photo-4472968.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
          <PortfolioGallery
          portfolioImage="https://images.pexels.com/photos/326503/pexels-photo-326503.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          portfolioContent="Project #1"
          />
      </div>
    </div>
  );
}

export default Portfolio;
